package com.eladfinish.bible.contest

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.WindowInsetsSides
import androidx.compose.foundation.layout.calculateEndPadding
import androidx.compose.foundation.layout.calculateStartPadding
import androidx.compose.foundation.layout.consumeWindowInsets
import androidx.compose.foundation.layout.displayCutout
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.only
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.union
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.material3.Scaffold
import androidx.compose.material3.ScaffoldDefaults
import androidx.compose.material3.SnackbarDuration
import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clipToBounds
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.unit.dp
import androidx.navigation.NavDestination
import androidx.navigation.NavHostController
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.rememberNavController
import com.eladfinish.bible.contest.analytics.crashlytics.AppCrashlytics
import com.eladfinish.bible.contest.colorPrimaryDark
import com.eladfinish.bible.contest.common.gender.HebrewGender
import com.eladfinish.bible.contest.common.gender.getHebrewGender
import com.eladfinish.bible.contest.common.gender.personalizeGender
import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.data.common.stringResolver.StringResolver
import com.eladfinish.bible.contest.di.getKoinInstance
import com.eladfinish.bible.contest.features.deeplink.DeepLinkHandler
import com.eladfinish.bible.contest.features.verseWidget.VerseWidgetEntryPoint
import com.eladfinish.bible.contest.navigation.BrowseScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.CompleteChapterScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.CompleteVerseScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.LexicographicalSortPdfViewerNavigationDestination
import com.eladfinish.bible.contest.navigation.LexicographicalSortScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.MikudScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.MiscScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.MonopolyScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.MultipleChoiceQuestionsScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.NamesScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.OpenQuestionsScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.PairMatchingScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.PastQuizzesNavigationDestination
import com.eladfinish.bible.contest.navigation.PyramidScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.RandomVerseScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.RootNavigationDestination
import com.eladfinish.bible.contest.navigation.SearchScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.ShonotScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.VerseWidgetScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.ViewContentTabsScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.back.BackInterceptorRegistry
import com.eladfinish.bible.contest.navigation.back.LocalBackInterceptorRegistry
import com.eladfinish.bible.contest.navigation.back.PlatformBackInterception
import com.eladfinish.bible.contest.navigation.back.handleBackClick
import com.eladfinish.bible.contest.navigation.composableAnimated
import com.eladfinish.bible.contest.navigation.navigateByCommand
import com.eladfinish.bible.contest.navigation.popBackStackSafely
import com.eladfinish.bible.contest.navigation.route
import com.eladfinish.bible.contest.platform.buildSignature
import com.eladfinish.bible.contest.screens.americanQuestions.menu.MultipleChoiceQuestionsMenu
import com.eladfinish.bible.contest.screens.americanQuestions.ui.AmericanQuestionsScreen
import com.eladfinish.bible.contest.screens.browse.contentOfChapter.ui.BookmarkScrollController
import com.eladfinish.bible.contest.screens.browse.contentOfChapter.ui.ChapterTabsWithHorizontalPager
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.BrowseMode
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.ShonotEntry
import com.eladfinish.bible.contest.screens.browse.tableOfContents.ui.TabsWithHorizontalPager
import com.eladfinish.bible.contest.screens.browse.tableOfContents.ui.menu.BrowseMenu
import com.eladfinish.bible.contest.screens.browse.tableOfContents.ui.menu.ChapterContentMenu
import com.eladfinish.bible.contest.screens.completeVerse.menu.CompleteVerseMenu
import com.eladfinish.bible.contest.screens.completeVerse.menu.ThreeDotsOption
import com.eladfinish.bible.contest.screens.completeVerse.menu.UnderlineOption
import com.eladfinish.bible.contest.screens.completeVerse.ui.CompleteVerseScreen
import com.eladfinish.bible.contest.screens.lexicographicalSort.LexicographicalSortPdfViewerStore
import com.eladfinish.bible.contest.screens.lexicographicalSort.LexicographicalSortStore
import com.eladfinish.bible.contest.screens.lexicographicalSort.ui.LexicographicalSortPdfViewerScreen
import com.eladfinish.bible.contest.screens.lexicographicalSort.ui.LexicographicalSortScreen
import com.eladfinish.bible.contest.screens.main.MainScreenState
import com.eladfinish.bible.contest.screens.main.MainScreenStore
import com.eladfinish.bible.contest.screens.main.MainScreenWrapper
import com.eladfinish.bible.contest.screens.main.data.ItemMode
import com.eladfinish.bible.contest.screens.main.menu.MainMenu
import com.eladfinish.bible.contest.screens.mikud.ui.MikudScreen
import com.eladfinish.bible.contest.screens.mikud.ui.menu.MikudMenu
import com.eladfinish.bible.contest.screens.misc.ui.MiscScreen
import com.eladfinish.bible.contest.screens.monopoly.ui.MonopolyScreen
import com.eladfinish.bible.contest.screens.names.ui.NamesScreen
import com.eladfinish.bible.contest.screens.openQuestions.menu.OpenQuestionsMenu
import com.eladfinish.bible.contest.screens.openQuestions.ui.OpenQuestionsScreen
import com.eladfinish.bible.contest.screens.pairMatching.menu.PairMatchingMenu
import com.eladfinish.bible.contest.screens.pairMatching.ui.PairMatchingScreen
import com.eladfinish.bible.contest.screens.pastQuizzes.GetPastQuizzesConfigUseCase
import com.eladfinish.bible.contest.screens.pastQuizzes.PastQuizzesScreen
import com.eladfinish.bible.contest.screens.pyramidCrossword.menu.PyramidMenu
import com.eladfinish.bible.contest.screens.pyramidCrossword.ui.PyramidCrosswordScreen
import com.eladfinish.bible.contest.screens.randomVerse.ui.RandomVerseScreen
import com.eladfinish.bible.contest.screens.randomVerse.ui.menu.RandomVerseMenu
import com.eladfinish.bible.contest.screens.search.menu.SearchMenu
import com.eladfinish.bible.contest.screens.search.model.SearchMode
import com.eladfinish.bible.contest.screens.search.model.SearchPlace
import com.eladfinish.bible.contest.screens.search.ui.SearchScreen
import com.eladfinish.bible.contest.screens.settings.ui.components.ComponentNavigationDestination
import com.eladfinish.bible.contest.screens.settings.ui.components.model.SubSettingsComponentType
import com.eladfinish.bible.contest.screens.settings.ui.screens.settingsGraph
import com.eladfinish.bible.contest.screens.verseWidget.ui.VerseWidgetScreen
import com.eladfinish.bible.contest.ui.ads.AdBannerSuppression
import com.eladfinish.bible.contest.ui.ads.AdMobBottomBanner
import com.eladfinish.bible.contest.ui.common.AppThemeState
import com.eladfinish.bible.contest.ui.common.LastBackPressState
import com.eladfinish.bible.contest.ui.common.SetSystemBackButtonEnabled
import com.eladfinish.bible.contest.ui.common.WithScreenConfiguration
import com.eladfinish.bible.contest.ui.common.WithSystemButtonsConfiguration
import com.eladfinish.bible.contest.ui.common.getCurrentFontFamily
import com.eladfinish.bible.contest.ui.common.rememberSafeUriHandler
import com.eladfinish.bible.contest.ui.components.ParchmentBackground
import com.eladfinish.bible.contest.ui.components.loaders.ScreenLoaderHost
import com.eladfinish.bible.contest.ui.components.toolbar.ConfigurableToolbar
import com.eladfinish.bible.contest.ui.components.toolbar.ToolbarConfigurator
import com.eladfinish.bible.contest.ui.components.toolbar.autohide.ToolbarAboveContent
import com.eladfinish.bible.contest.ui.components.toolbar.autohide.ToolbarAutoHide
import com.eladfinish.bible.contest.ui.components.toolbar.specifyWithNavController
import com.eladfinish.bible.contest.ui.extensions.LocalNavigationBarInset
import com.eladfinish.bible.contest.ui.layout.LocalIsKeyboardOpen
import com.eladfinish.bible.contest.ui.layout.isKeyboardCoveringShortWindow
import com.eladfinish.bible.contest.ui.layout.rememberIsKeyboardOpen
import com.eladfinish.bible.contest.ui.menus.actions.BrowseToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.ChapterContentToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.CompleteVerseToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.MainToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.MikudToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.MultipleChoiceQuestionsToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.OpenQuestionsToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.PairMatchingToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.PyramidCrosswordToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.RandomVerseToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.SearchToolbarAction
import com.eladfinish.bible.contest.ui.menus.viewModels.ToolbarActionBusViewModel
import com.eladfinish.bible.contest.ui.menus.viewModels.emitter
import com.eladfinish.bible.contest.ui.scaffold.AppSnackbarHost
import com.eladfinish.bible.contest.ui.scaffold.SnackbarActions
import com.eladfinish.bible.contest.ui.scaffold.createSnackbarActions
import com.russhwolf.settings.ObservableSettings
import com.russhwolf.settings.Settings
import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.compose.colorResource
import dev.icerock.moko.resources.desc.StringDesc
import dev.icerock.moko.resources.desc.desc
import io.github.aakira.napier.Napier
import kotlinx.coroutines.flow.filterNotNull
import kotlinx.coroutines.flow.first
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf

@Composable
fun BibleContestApp(
    mainScreenStore: MainScreenStore = koinViewModel(),
    navController: NavHostController = rememberNavController(),
    onToolbarConfiguratorReady: (ToolbarConfigurator) -> Unit = {},
    stringResolver: StringResolver = getKoinInstance<StringResolver>(),
    settings: Settings = getKoinInstance<Settings>(),
    observableSettings: ObservableSettings = getKoinInstance<ObservableSettings>(),
    toolbarActionBus: ToolbarActionBusViewModel = remember { ToolbarActionBusViewModel() },
    isDebug: Boolean = false,
    logEvent: (String) -> Unit,
    logEventWithParameter: (eventName: String, singleKey: String, singleValue: String) -> Unit,
    appActions: AppActions,
    onHebrewGenderConfirmed: (HebrewGender) -> Unit,
    versionInfo: String,
    interceptBack: (() -> Boolean)? = null,
    onBackClick: (poppedDestination: NavDestination?) -> Unit = {},
    onStartDestinationBackClick: () -> Unit = {},
    statusBar: @Composable () -> Unit = {},
    snackbarHostState: SnackbarHostState = remember { SnackbarHostState() },
    snackbarActions: SnackbarActions? = null,
    deepLinkHandler: DeepLinkHandler = getKoinInstance<DeepLinkHandler>(),
) {
    val coroutineScope = rememberCoroutineScope()

    val finalSnackbarActions = snackbarActions ?: remember(snackbarHostState, coroutineScope, stringResolver) {
        createSnackbarActions(
            hostState = snackbarHostState,
            scope = coroutineScope,
            stringResolver = stringResolver,
        )
    }

    // A duel link opens its room in the browser instead while the app's part of ראש בראש (or the
    // whole "חידונים אמיתיים" screen) is switched off remotely.
    val pastQuizzesConfig = remember { getKoinInstance<GetPastQuizzesConfigUseCase>() }
    val deepLinkUriHandler = rememberSafeUriHandler(onFailure = { e, _ -> AppCrashlytics.logException(e) })
    LaunchedEffect(navController) {
        // The graph is set when the NavHost is composed, which is after this effect first runs on iOS (the
        // content of the Scaffold is composed at layout): a link that opened the app, already pending, would be
        // navigated to before there is a graph, and the app closes at launch. The first entry exists once the
        // graph is set.
        navController.currentBackStackEntryFlow.first()
        deepLinkHandler.pendingDestination.filterNotNull().collect { destination ->
            val duelCode = (destination as? PastQuizzesNavigationDestination)?.duelCode
            if (duelCode != null && (pastQuizzesConfig.isDisabled() || pastQuizzesConfig.isDuelDisabled())) {
                deepLinkUriHandler.openUri(pastQuizzesConfig.duelBrowserUrl(duelCode))
            } else {
                navController.navigate(route = destination)
            }
            deepLinkHandler.consume()
        }
    }

    val dismissSnackbar: () -> Boolean = {
        val wasShown = snackbarHostState.currentSnackbarData != null
        snackbarHostState.currentSnackbarData?.dismiss()
        wasShown
    }

    val lastBackPressState = remember { LastBackPressState() }
    val mainState by mainScreenStore.observeState().collectAsState()
    // a screen may hide the banner for a while (AdBannerSuppression)
    val isAdBannerSuppressed by remember { getKoinInstance<AdBannerSuppression>() }.isSuppressed.collectAsState()
    val showAdBanner = mainState.shouldShowAds && !isAdBannerSuppressed
    val toolbarAutoHide = remember { getKoinInstance<ToolbarAutoHide>() }

    val shouldUseDoubleBackToExit: () -> Boolean = {
        navController.currentDestination?.route == RootNavigationDestination.route &&
                mainState.itemMode == ItemMode.REGULAR
    }

    val onConfirmExitToast: () -> Unit = {
        finalSnackbarActions.showToast(
            SharedRes.strings.confirm_exit
                .desc()
                .personalizeGender(hebrewGender = settings.getHebrewGender())
        )
    }

    val internalInterceptor = remember { mutableStateOf<(() -> Boolean)?>(null) }

    val registry = remember {
        BackInterceptorRegistry { interceptor ->
            internalInterceptor.value = interceptor
        }
    }

    // Combine external interceptBack (if exists) + internal screen interceptor
    val combinedInterceptBack: () -> Boolean = {
        (interceptBack?.invoke() == true).also { Napier.d("combinedInterceptBack interceptBack: $it") }
                || (internalInterceptor.value?.invoke() == true).also { Napier.d("combinedInterceptBack internalInterceptor: $it") }
    }

    val currentCombinedInterceptBack by rememberUpdatedState(combinedInterceptBack)
    DisposableEffect(Unit) {
        PlatformBackInterception.interceptBack = { currentCombinedInterceptBack() }
        onDispose { PlatformBackInterception.interceptBack = null }
    }

    MyApplicationTheme(
        themeState = AppThemeState(fontFamily = getCurrentFontFamily(settings)),
    ) {
        CompositionLocalProvider(
            LocalAppActions provides appActions,
            LocalBackInterceptorRegistry provides registry,
        ) {
            CompositionLocalProvider(LocalIsKeyboardOpen provides rememberIsKeyboardOpen()) {
                WithSystemButtonsConfiguration(
                    onBackPressed = {
                        handleBackClick(
                            navController = navController,
                            dismissSnackbar = dismissSnackbar,
                            shouldUseDoubleBackToExit = shouldUseDoubleBackToExit,
                            lastBackPressState = lastBackPressState,
                            onConfirmExitToast = onConfirmExitToast,
                            exitApp = appActions::exitApp,
                            onBackClick = onBackClick,
                            onStartDestinationBackClick = onStartDestinationBackClick,
                            interceptBack = combinedInterceptBack,
                            source = "bottom system bar",
                        )
                    },
                ) {
                    WithScreenConfiguration(
                        decorateConfig = {
                            specifyWithNavController(
                                navController = navController,
                                onAppIconClick = {
                                    appActions.openAppStore()
                                },
                                onBackClick = {
                                    handleBackClick(
                                        navController = navController,
                                        dismissSnackbar = dismissSnackbar,
                                        shouldUseDoubleBackToExit = shouldUseDoubleBackToExit,
                                        lastBackPressState = lastBackPressState,
                                        onConfirmExitToast = onConfirmExitToast,
                                        exitApp = appActions::exitApp,
                                        onBackClick = onBackClick,
                                        onStartDestinationBackClick = onStartDestinationBackClick,
                                        interceptBack = combinedInterceptBack,
                                        source = "top toolbar",
                                    )
                                },
                            )
                        },
                        onToolbarConfiguratorReady = onToolbarConfiguratorReady,
                    ) { toolbarConfiguration, isLoading ->
                        Napier.d("toolbarConfiguration_: $toolbarConfiguration")
                        Napier.d("isLoading_: $isLoading")
                        Scaffold(
                            modifier = Modifier
                                .fillMaxSize()
                                .imePadding(),
                            // In landscape the camera cutout sits at the side, where the content must not go.
                            contentWindowInsets = ScaffoldDefaults.contentWindowInsets.union(
                                WindowInsets.displayCutout.only(WindowInsetsSides.Horizontal)
                            ),
                            topBar = {
                                Column {
                                    statusBar()

                                    // The toolbar is in the content (ToolbarAboveContent): it may hide, and this stays.
                                    if (toolbarConfiguration != null || isKeyboardCoveringShortWindow()) {
                                        Spacer(
                                            modifier = Modifier
                                                .fillMaxWidth()
                                                .background(colorResource(SharedRes.colors.colorPrimaryDark))
                                                .statusBarsPadding()
                                        )
                                    }
                                }
                            },
                            snackbarHost = {
                                AppSnackbarHost(
                                    hostState = snackbarHostState,
                                    modifier = Modifier,
                                )
                            },
                            bottomBar = {
                                if (showAdBanner) {
                                    // Kept in the composition at no height: removing it would load a new ad
                                    // every time the keyboard closes.
                                    Column(
                                        modifier = Modifier
                                            .then(if (isKeyboardCoveringShortWindow()) Modifier.height(0.dp).clipToBounds() else Modifier)
                                            .navigationBarsPadding()
                                            .windowInsetsPadding(WindowInsets.displayCutout.only(WindowInsetsSides.Horizontal))
                                    ) {
                                        AdMobBottomBanner()
                                    }
                                }
                            }
                        ) { paddings ->
                            // Edge-to-edge: with no bottom bar (ad banner) the screens draw behind the
                            // system navigation bar, and each screen pads the end of its own scrollable
                            // content by LocalNavigationBarInset, so the last item still scrolls above it.
                            val layoutDirection = LocalLayoutDirection.current
                            val navHostPaddings = PaddingValues(
                                start = paddings.calculateStartPadding(layoutDirection),
                                end = paddings.calculateEndPadding(layoutDirection),
                                bottom = if (showAdBanner) paddings.calculateBottomPadding() else 0.dp,
                            )
                            val statusBarPaddings = PaddingValues(top = paddings.calculateTopPadding())
                            val navigationBarInset = if (showAdBanner) 0.dp else paddings.calculateBottomPadding()
                            CompositionLocalProvider(LocalNavigationBarInset provides navigationBarInset) {
                                ParchmentBackground {
                                    Box(
                                        modifier = Modifier
                                            .padding(statusBarPaddings)
                                            .consumeWindowInsets(statusBarPaddings)
                                    ) {
                                        ToolbarAboveContent(
                                            toolbarAutoHide = toolbarAutoHide,
                                            toolbar = {
                                                if (!isKeyboardCoveringShortWindow()) {
                                                    toolbarConfiguration?.let {
                                                        ConfigurableToolbar(
                                                            configuration = it,
                                                            isDebug = isDebug,
                                                            hebrewGender = settings.getHebrewGender(),
                                                        )
                                                    }
                                                }
                                            },
                                            content = {
                                                AppNavGraph(
                                                    mainScreenStore = mainScreenStore,
                                                    navController = navController,
                                                    paddings = navHostPaddings,
                                                    toolbarActionBus = toolbarActionBus,
                                                    logEvent = logEvent,
                                                    logEventWithParameter = logEventWithParameter,
                                                    showToast = { finalSnackbarActions.showToast(it) },
                                                    showToastDesc = { finalSnackbarActions.showToast(it) },
                                                    showToastRes = { finalSnackbarActions.showToast(it) },
                                                    showToastResLongDuration = { message, duration ->
                                                        finalSnackbarActions.showToast(message, duration)
                                                    },
                                                    showSnackbar = { message, actionLabel, duration, onActionPerformed ->
                                                        finalSnackbarActions.showSnackbar(message, actionLabel, duration, onActionPerformed)
                                                    },
                                                    showLoadingSnackbar = { finalSnackbarActions.showLoadingSnackbar(it) },
                                                    dismissSnackbar = dismissSnackbar,
                                                    snackbarHostState = snackbarHostState,
                                                    settings = settings,
                                                    observableSettings = observableSettings,
                                                    onHebrewGenderConfirmed = onHebrewGenderConfirmed,
                                                    versionInfo = versionInfo,
                                                )
                                            },
                                        )
                                    }
                                }
                            }

                            // We call this here so it registers its BackHandler AFTER the NavHost is potentially initialized
                            // This allows it to intercept back presses even when NavHost is active
                            SetSystemBackButtonEnabled(isEnabled = true)
                        }

                        // Kept always in the composition to avoid a Compose Multiplatform repaint issue
                        // where conditionally removing the loader (if isLoading) can leave a “ghost” overlay on screen.
                        ScreenLoaderHost(isLoading = isLoading)
                    }
                }
            }
        }
    }
}

@Composable
private fun AppNavGraph(
    mainScreenStore: MainScreenStore,
    navController: NavHostController,
    paddings: PaddingValues,
    toolbarActionBus: ToolbarActionBusViewModel,
    logEvent: (String) -> Unit,
    logEventWithParameter: (eventName: String, singleKey: String, singleValue: String) -> Unit,
    showToast: (message: String) -> Unit,
    showToastDesc: (message: StringDesc) -> Unit,
    showToastRes: (message: StringResource) -> Unit,
    showToastResLongDuration: (message: StringResource, duration: SnackbarDuration) -> Unit,
    showSnackbar: (message: StringDesc, actionLabel: StringDesc?, duration: SnackbarDuration, onActionPerformed: () -> Unit) -> Unit,
    showLoadingSnackbar: (message: String) -> Unit,
    dismissSnackbar: () -> Boolean,
    snackbarHostState: SnackbarHostState,
    settings: Settings,
    observableSettings: ObservableSettings,
    onHebrewGenderConfirmed: (HebrewGender) -> Unit,
    versionInfo: String,
) {
    Napier.d("BUILD_SIGNATURE = ${buildSignature()}")

    val currentShowToastDesc by rememberUpdatedState(showToastDesc)
    val currentShowToastRes by rememberUpdatedState(showToastRes)

    NavHost(
        navController = navController,
        startDestination = RootNavigationDestination,
        modifier = Modifier
            .fillMaxSize()
            .padding(paddings)
            .consumeWindowInsets(paddings)
    ) {
        composableAnimated<RootNavigationDestination> { destination ->
            val mainState: MainScreenState by mainScreenStore.observeState().collectAsState()
            MainMenu(
                title = destination.title,
                toolbarEmitter = toolbarActionBus.emitter<MainToolbarAction>(),
                hebrewGender = settings.getHebrewGender(),
                shouldShowAds = mainState.shouldShowAds,
                canPurchaseAdFree = mainState.canPurchaseAdFree,
                isDebugMode = mainState.isDebugMode,
                isHelpInToolbar = mainState.isHelpInToolbar,
            )
            MainScreenWrapper(
                mainScreenStore = mainScreenStore,
                toolbarActionBus = toolbarActionBus,
                navController = navController,
                onHebrewGenderConfirmed = onHebrewGenderConfirmed,
                showToast = currentShowToastDesc,
                logEvent = logEvent,
            )
        }

        composableAnimated<NamesScreenNavigationDestination> {
            NamesScreen(
                showToastStringResource = currentShowToastRes,
            )
        }

        settingsGraph(
            navController = navController,
            settings = settings,
            observableSettings = observableSettings,
            versionInfo = versionInfo,
            currentShowToastStringResource = currentShowToastRes,
            logEvent = logEventWithParameter,
        )

        composableAnimated<PyramidScreenNavigationDestination> { destination ->
            PyramidMenu(
                title = destination.title,
                toolbarEmitter = toolbarActionBus.emitter<PyramidCrosswordToolbarAction>(),
            )
            PyramidCrosswordScreen(
                toolbarActionBus = toolbarActionBus,
                showToast = showToast,
            )
        }

        composableAnimated<RandomVerseScreenNavigationDestination> { destination ->
            RandomVerseMenu(
                title = destination.title,
                toolbarEmitter = toolbarActionBus.emitter<RandomVerseToolbarAction>(),
            )

            RandomVerseScreen(
                toolbarActionBus = toolbarActionBus,
                navController = navController,
                openMikud = {
                    navController.navigate(route = MikudScreenNavigationDestination)
                },
                openBrowse = { bookIndex, chapterIndex ->
                    navController.navigate(
                        route = BrowseScreenNavigationDestination(
                            fromDialog = true,
                            bookIndex = bookIndex,
                            chapterIndex = chapterIndex,
                        )
                    )
                },
                openSeveralRandomVerses = {
                    navController.navigate(
                        route = OpenQuestionsScreenNavigationDestination(isMultipleRandomVersesMode = true),
                    )
                },
                openRandomVerseSettings = {
                    navController.navigate(
                        route = ComponentNavigationDestination(type = SubSettingsComponentType.RANDOM_VERSE_SETTINGS),
                    )
                },
                openVerseWidget = {
                    navController.navigate(VerseWidgetScreenNavigationDestination(VerseWidgetEntryPoint.RANDOM_VERSE_PROMPT))
                },
                showToastStringResource = currentShowToastRes,
                showSnackbar = showSnackbar,
                dismissSnackbar = dismissSnackbar,
            )
        }

        composableAnimated<CompleteVerseScreenNavigationDestination> { destination ->
            CompleteVerseMenu(
                title = destination.title,
                toolbarEmitter = toolbarActionBus.emitter<CompleteVerseToolbarAction>(),
                underlineSelected = UnderlineOption.HIDE_SOME_WORDS,
                threeDotsSelected = ThreeDotsOption.SHOW_BEGINNING,
            )
            CompleteVerseScreen(
                toolbarActionBus = toolbarActionBus,
                showToast = showToast,
                showToastRes = showToastRes,
                showSnackbar = showSnackbar,
                dismissSnackbar = dismissSnackbar,
                openChapter = { bookIndex, chapterIndex ->
                    navController.navigate(
                        route = BrowseScreenNavigationDestination(
                            fromDialog = true,
                            bookIndex = bookIndex,
                            chapterIndex = chapterIndex,
                        )
                    )
                },
            )
        }

        composableAnimated<SearchScreenNavigationDestination> { destination ->
            val searchMode = SearchMode.valueOf(
                settings.getString(key = Constants.PREF_SEARCH_MODE, defaultValue = SearchMode.REGULAR_SEARCH.name)
            )

            SearchMenu(
                title = destination.title,
                toolbarEmitter = toolbarActionBus.emitter<SearchToolbarAction>(),
                searchModeSelected = searchMode,
                whereToSearchSelected = SearchPlace.WHOLE_BIBLE,
            )

            SearchScreen(
                initialText = destination.text,
                showToast = showToast,
                showToastStringDesc = currentShowToastDesc,
                toolbarActionBus = toolbarActionBus,
                showSnackbar = showSnackbar,
            )
        }

        composableAnimated<CompleteChapterScreenNavigationDestination> { destination ->
            BrowseMenu(
                title = destination.title,
                toolbarEmitter = toolbarActionBus.emitter<BrowseToolbarAction>(),
                isCompleteChapter = true,
            )

            TabsWithHorizontalPager(
                completeChapter = true,
                fromDialog = false,
                toolbarActionBus = toolbarActionBus,
                navigator = {
                    navController.navigateByCommand(command = it)
                },
                logEvent = logEvent,
                showToastStringResource = currentShowToastRes,
                onNavigateBack = {
                    navController.popBackStackSafely()
                },
            )
        }

        composableAnimated<PairMatchingScreenNavigationDestination> { destination ->
            PairMatchingMenu(
                title = destination.title,
                toolbarEmitter = toolbarActionBus.emitter<PairMatchingToolbarAction>(),
            )

            PairMatchingScreen(
                toolbarActionBus = toolbarActionBus,
                showToast = showToast,
                showToastDesc = showToastDesc,
                showToastRes = showToastRes,
                onNavigateToMultipleChoice = {
                    navController.navigate(MultipleChoiceQuestionsScreenNavigationDestination(fromPairMatching = true))
                },
                onOpenSettings = {
                    navController.navigate(
                        route = ComponentNavigationDestination(type = SubSettingsComponentType.PAIR_MATCHING_SETTINGS),
                    )
                },
            )
        }

        composableAnimated<MultipleChoiceQuestionsScreenNavigationDestination> { destination ->
            MultipleChoiceQuestionsMenu(
                title = destination.title,
                toolbarEmitter = toolbarActionBus.emitter<MultipleChoiceQuestionsToolbarAction>(),
            )
            AmericanQuestionsScreen(
                fromPairMatching = destination.fromPairMatching,
                toolbarActionBus = toolbarActionBus,
                navController = navController,
                showToastStringResource = currentShowToastRes,
                openSettings = { navController.navigate(route = it) },
            )
        }

        composableAnimated<OpenQuestionsScreenNavigationDestination> { destination ->
            OpenQuestionsMenu(
                title = destination.title,
                toolbarEmitter = toolbarActionBus.emitter<OpenQuestionsToolbarAction>(),
                showMoreQuestionsAction = false,
            )

            OpenQuestionsScreen(
                isMultipleRandomVersesMode = destination.isMultipleRandomVersesMode,
                toolbarActionBus = toolbarActionBus,
                showToast = showToast,
                showToastRes = showToastRes,
                navigator = {
                    navController.navigateByCommand(command = it)
                },
            )
        }

        composableAnimated<BrowseScreenNavigationDestination> { destination ->
            BrowseMenu(
                title = destination.title,
                toolbarEmitter = toolbarActionBus.emitter<BrowseToolbarAction>(),
                isCompleteChapter = false,
            )

            TabsWithHorizontalPager(
                completeChapter = false,
                fromDialog = destination.fromDialog,
                bookIndex = destination.bookIndex,
                chapterIndex = destination.chapterIndex,
                verse = destination.verse,
                toolbarActionBus = toolbarActionBus,
                navigator = {
                    navController.navigateByCommand(command = it)
                },
                logEvent = logEvent,
                showToastStringResource = currentShowToastRes,
                onNavigateBack = {
                    navController.popBackStackSafely()
                },
            )
        }

        composableAnimated<ViewContentTabsScreenNavigationDestination> { destination ->
            with(destination) {
                ChapterContentRoute(
                    title = title,
                    browseMode = BrowseMode.valueOf(browseMode),
                    isCompleteChapter = isCompleteChapter,
                    bookIndex = indexPickedBook,
                    partIndex = indexPickedPart,
                    bookmarkScrollY = bookmarkScrollY,
                    bookmarkTextOffset = bookmarkTextOffset,
                    completionDetails = completionDetails,
                    showOnqelos = showOnqelos,
                    verse = verse,
                    toolbarActionBus = toolbarActionBus,
                    showToast = showToast,
                    showToastStringResource = currentShowToastRes,
                    showSnackbar = showSnackbar,
                    navController = navController,
                )
            }
        }

        composableAnimated<ShonotScreenNavigationDestination> { destination ->
            ChapterContentRoute(
                title = destination.title,
                browseMode = BrowseMode.SHONOT_MODE,
                isCompleteChapter = false,
                bookIndex = 1,
                // No book edges in this mode: the parts are numbered from 0.
                partIndex = (ShonotEntry.fromSlug(destination.entry) ?: ShonotEntry.ROSH_CHODESH).ordinal,
                bookmarkScrollY = -1,
                completionDetails = null,
                showOnqelos = false,
                toolbarActionBus = toolbarActionBus,
                showToast = showToast,
                showToastStringResource = currentShowToastRes,
                showSnackbar = showSnackbar,
                navController = navController,
            )
        }

        composableAnimated<MikudScreenNavigationDestination> { destination ->
            MikudMenu(
                title = destination.title,
                toolbarEmitter = toolbarActionBus.emitter<MikudToolbarAction>(),
            )
            MikudScreen(
                toolbarActionBus = toolbarActionBus,
                showToastStringResource = currentShowToastRes,
                showToast = showToast,
                onNavigateBack = {
                    navController.popBackStackSafely()
                },
            )
        }

        composableAnimated<PastQuizzesNavigationDestination> { destination ->
            PastQuizzesScreen(
                onNavigateBack = {
                    navController.popBackStackSafely()
                },
                duelCode = destination.duelCode,
            )
        }

        composableAnimated<LexicographicalSortScreenNavigationDestination> { destination ->
            LexicographicalSortScreen(
                store = koinViewModel(
                    parameters = {
                        parametersOf(
                            LexicographicalSortStore.Companion.LexicographicalSortStoreParams(
                                bookIndex = destination.bookIndex,
                                chapterIndex = destination.chapterIndex,
                            )
                        )
                    }
                ),
                showToastStringResource = showToastResLongDuration,
                navigateToPdfViewer = { bookIndex, chapterIndex, outputChaptersOrdinal ->
                    navController.navigate(
                        LexicographicalSortPdfViewerNavigationDestination(
                            bookIndex = bookIndex,
                            chapterIndex = chapterIndex,
                            outputChaptersOrdinal = outputChaptersOrdinal,
                        )
                    )
                },
            )
        }

        composableAnimated<LexicographicalSortPdfViewerNavigationDestination> { destination ->
            LexicographicalSortPdfViewerScreen(
                store = koinViewModel(
                    parameters = {
                        parametersOf(
                            LexicographicalSortPdfViewerStore.Companion.Params(
                                bookIndex = destination.bookIndex,
                                chapterIndex = destination.chapterIndex,
                                outputChaptersOrdinal = destination.outputChaptersOrdinal,
                            )
                        )
                    }
                ),
                showToast = showToast,
                showLoadingSnackbar = showLoadingSnackbar,
                dismissSnackbar = { dismissSnackbar() },
                showSnackbar = showSnackbar,
            )
        }

        composableAnimated<MiscScreenNavigationDestination> {
            MiscScreen(
                logEvent = logEvent,
                onNavigateToSeminar = { navController.navigate(MonopolyScreenNavigationDestination) },
                showToast = showToast,
            )
        }

        composableAnimated<VerseWidgetScreenNavigationDestination>(
            typeMap = VerseWidgetScreenNavigationDestination.typeMap,
        ) { destination ->
            VerseWidgetScreen(entryPoint = destination.entryPoint)
        }

        composableAnimated<MonopolyScreenNavigationDestination> {
            MonopolyScreen(showToast = showToast, snackbarHostState = snackbarHostState)
        }
    }
}

/** The chapter screen, with its toolbar menu: of a book's parts, or of the entries of the "שונות" tab. */
@Composable
private fun ChapterContentRoute(
    title: String,
    browseMode: BrowseMode,
    isCompleteChapter: Boolean,
    bookIndex: Int,
    partIndex: Int,
    bookmarkScrollY: Int,
    bookmarkTextOffset: Int = -1,
    completionDetails: String?,
    showOnqelos: Boolean,
    verse: Int = 0,
    toolbarActionBus: ToolbarActionBusViewModel,
    showToast: (message: String) -> Unit,
    showToastStringResource: (StringResource) -> Unit,
    showSnackbar: (message: StringDesc, actionLabel: StringDesc?, duration: SnackbarDuration, onActionPerformed: () -> Unit) -> Unit,
    navController: NavHostController,
) {
    val bookmarkScrollController = remember { BookmarkScrollController() }

    ChapterContentMenu(
        title = title,
        toolbarEmitter = toolbarActionBus.emitter<ChapterContentToolbarAction>(),
        isCompleteChapter = isCompleteChapter,
        browseMode = browseMode,
        bookmarkScrollController = bookmarkScrollController,
    )

    ChapterTabsWithHorizontalPager(
        browseMode = browseMode,
        isCompleteChapter = isCompleteChapter,
        bookIndex = bookIndex,
        partIndex = partIndex,
        bookmarkScrollY = bookmarkScrollY,
        bookmarkTextOffset = bookmarkTextOffset,
        completionDetails = completionDetails,
        showOnqelos = showOnqelos,
        verse = verse,
        showToast = showToast,
        showToastStringResource = showToastStringResource,
        showSnackbar = showSnackbar,
        navigator = {
            navController.navigateByCommand(command = it)
        },
        toolbarActionBus = toolbarActionBus,
        onBookmarkScrollYChanged = { y, textOffset ->
            bookmarkScrollController.currentScrollY = y
            bookmarkScrollController.currentTextOffset = textOffset
        },
    )
}
